// const isDevelopment = process.env.NODE_ENV === 'development';

// const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001';

// export const API_URL = isDevelopment 
//   ? 'http://localhost:5001/api'
//   : `${API_BASE_URL}/api`;

// export const CONTACT_API = `${API_URL}/contact`;
// export const PROMO_API = `${API_URL}/promo`;
// export const PROMO_GENERAL_API = `${API_URL}/promo-general`;
// export const CAREERS_API = `${API_URL}/careers`;
// export const SUBSCRIBE_API = `${API_URL}/subscribe`;


import { API_URL } from './constants';

export const CONTACT_API = `${API_URL}/contact`;
export const PROMO_API = `${API_URL}/promo`;
export const PROMO_GENERAL_API = `${API_URL}/promo-general`;
export const CAREERS_API = `${API_URL}/careers`;
export const SUBSCRIBE_API = `${API_URL}/subscribe`;